import { render, staticRenderFns } from "./StaffPlacementForm.vue?vue&type=template&id=4a921267&"
import script from "./StaffPlacementForm.vue?vue&type=script&lang=js&"
export * from "./StaffPlacementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports